import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { Icon } from '../icon';
import { checkPassword } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { CheckPasswordRule, PasswordHintProps as Props } from './types';

export const PasswordHint = memo(({ className, value }: Props) => {
  const updatedCheckData: Record<CheckPasswordRule, boolean> = {
    length: value.length >= 8,
  };

  return (
    <Styled.CheckPassword className={className}>
      {checkPassword.map((i) => (
        <Styled.Title
          className={classnames({ success: updatedCheckData[i.condition] })}
          variant="body2"
          key={i.condition}
        >
          {updatedCheckData[i.condition] && i.icon ? (
            <Icon name={i.icon} size={15} />
          ) : (
            <Icon name="alert-fill" sxx={SX.errorIcon} size={15} />
          )}

          {i.title}
        </Styled.Title>
      ))}
    </Styled.CheckPassword>
  );
});

PasswordHint.displayName = 'PasswordHint';
